// extracted by mini-css-extract-plugin
module.exports = {"product-wrapper-component":"ProductItemWrapper_product-wrapper-component__bA49L","alternative":"ProductItemWrapper_alternative__v396e"};